
(() => {
  'use strict';

  if (window.__tvCartPromotionsLoaded) return;
  window.__tvCartPromotionsLoaded = true;

  const root = window.Shopify?.routes?.root || '/';
  const SHIPPING_THRESHOLD = 5000;
  const nativeFetch = window.fetch.bind(window);

  let refreshTimer = null;

  const cartUrl = (endpoint) => root + endpoint;

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency
    }).format(cents / 100);
  };

  async function getCart() {
    const response = await nativeFetch(cartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(
        `Warenkorb konnte nicht geladen werden (${response.status}).`
      );
    }

    return response.json();
  }

  function renderPromotions(cart) {
    document.querySelectorAll('[data-tv-cart-promos]').forEach((widget) => {
      const threshold = Number(
        widget.dataset.shippingThreshold || SHIPPING_THRESHOLD
      );

      const remaining = Math.max(0, threshold - cart.total_price);
      const percentage = threshold > 0
        ? Math.min(100, (cart.total_price / threshold) * 100)
        : 100;

      const bar = widget.querySelector('[data-tv-shipping-bar]');
      const progress = widget.querySelector(
        '[data-tv-shipping-progress]'
      );
      const amount = widget.querySelector(
        '[data-tv-shipping-amount]'
      );
      const message = widget.querySelector(
        '[data-tv-shipping-message]'
      );

      if (bar) {
        bar.style.width = `${percentage}%`;
      }

      if (progress) {
        progress.setAttribute(
          'aria-valuenow',
          String(Math.min(50, cart.total_price / 100))
        );
      }

      if (amount) {
        amount.textContent = remaining > 0
          ? `Noch ${formatMoney(remaining)}`
          : 'Erreicht!';
      }

      if (message) {
        message.textContent = remaining > 0
          ? `Dir fehlen noch ${formatMoney(remaining)} bis zum kostenlosen Versand.`
          : 'Du hast die Schwelle für kostenlosen Versand erreicht!';
      }

      // Alte Geschenk-Anzeige ausblenden, falls sie noch im Snippet steht.
      const giftPromo = widget.querySelector('.tv-cart-promo--gift');

      if (giftPromo) {
        giftPromo.remove();
      }
    });
  }

  async function refreshCartPromotions() {
    try {
      const cart = await getCart();
      renderPromotions(cart);
    } catch (error) {
      console.error(
        '[TornadoVapes] Versandfortschritt konnte nicht aktualisiert werden:',
        error
      );
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartPromotions, 300);
  }

  // Änderungen am Warenkorb erkennen.
  window.fetch = async (...args) => {
    const input = args[0];
    const url = typeof input === 'string'
      ? input
      : input?.url || '';

    const response = await nativeFetch(...args);

    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
      scheduleRefresh();
    }

    return response;
  };

  document.addEventListener('change', (event) => {
    if (
      event.target instanceof Element &&
      event.target.matches(
        'input[name="updates[]"], input[data-quantity-variant-id]'
      )
    ) {
      scheduleRefresh();
    }
  });

  document.addEventListener('click', (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest(
        '[name="add"], [data-cart-remove], cart-remove-button, ' +
        '[data-quantity-minus], [data-quantity-plus]'
      )
    ) {
      scheduleRefresh();
    }
  });

  refreshCartPromotions();
})();
